module.exports = __webpack_public_path__ + "img/chongzhi.b4e7cd20.png";